module.exports = __webpack_public_path__ + "static/media/16616947931644844271reception.f533737b.jpg";